export const SOCIAL_LINKS = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/robertqhammock/',
  },
  {
    label: 'GitHub',
    href: 'https://github.com/rhammock1',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/robert.hammock1',
  },
];
